var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('TodoBoard'),_vm._v(" "),_c('ApplicantsBoard'),_vm._v(" "),_c('ShiftsBoard'),_vm._v(" "),_c('StandByListBoard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }